/**
 * Bloomreach product cards: recommendation carousels, add-to-cart, and
 * truncated-title tooltips (native title only when line-clamped).
 */
(function () {
  function getItems(scroller) {
    return Array.from(scroller.querySelectorAll('.blm-recommendation__product'));
  }

  function nearestIndex(scroller) {
    const items = getItems(scroller);
    if (!items.length) return 0;

    var scrollLeft = scroller.scrollLeft;
    var best = 0;
    var bestDist = Infinity;

    for (var i = 0; i < items.length; i++) {
      var dist = Math.abs(items[i].offsetLeft - scrollLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }

    return best;
  }

  function maxStartIndex(scroller) {
    const items = getItems(scroller);
    if (!items.length) return 0;

    var maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
    var maxIdx = 0;

    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetLeft <= maxScroll + 1) maxIdx = i;
    }

    return maxIdx;
  }

  function scrollByItems(scroller, direction) {
    const items = getItems(scroller);
    if (!items.length) return;

    var idx =
      typeof scroller._brCarouselIndex === 'number'
        ? scroller._brCarouselIndex
        : nearestIndex(scroller);

    var next = Math.min(Math.max(idx + direction, 0), maxStartIndex(scroller));
    var maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
    var target = Math.min(items[next].offsetLeft, maxScroll);

    scroller._brCarouselIndex = next;
    scroller.scrollTo({ left: target, behavior: 'smooth' });
  }

  function updateArrows(root) {
    const scroller = root.querySelector('.blm-recommendation__products');
    const prev = root.querySelector('.blm-carousel-previous');
    const next = root.querySelector('.blm-carousel-next');
    if (!scroller) return;

    const maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth - 1, 0);
    const atStart = scroller.scrollLeft <= 2;
    const atEnd = scroller.scrollLeft >= maxScroll;

    if (prev) prev.classList.toggle('blm-invisible', atStart);
    if (next) next.classList.toggle('blm-invisible', atEnd || maxScroll <= 0);
  }

  /* Strip Bloomreach listeners so only our scroll-based carousel runs. */
  function takeOverArrow(el) {
    if (!el || !el.parentNode) return null;
    var clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
    return clone;
  }

  function bindCarousel(root) {
    if (!root || root.dataset.brCarouselBound === 'true') return;
    const scroller = root.querySelector('.blm-recommendation__products');
    if (!scroller) return;

    var prev = takeOverArrow(root.querySelector('.blm-carousel-previous'));
    var next = takeOverArrow(root.querySelector('.blm-carousel-next'));

    root.dataset.brCarouselBound = 'true';
    scroller._brCarouselIndex = 0;

    if (prev) {
      prev.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          scrollByItems(scroller, -1);
        },
        true
      );
    }

    if (next) {
      next.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          scrollByItems(scroller, 1);
        },
        true
      );
    }

    scroller.addEventListener(
      'scroll',
      function () {
        /* Keep index in sync after manual swipe / momentum. */
        if (!scroller._brScrollSettle) {
          scroller._brScrollSettle = setTimeout(function () {
            scroller._brScrollSettle = null;
            scroller._brCarouselIndex = nearestIndex(scroller);
            updateArrows(root);
          }, 80);
        }
        updateArrows(root);
      },
      { passive: true }
    );

    updateArrows(root);
  }

  function initCarousels(scope) {
    const root = scope || document;
    root
      .querySelectorAll('.blm-recommendation-widget-content.blm-rec-theme')
      .forEach(bindCarousel);
  }

  if (!customElements.get('br-recommendation-tabs')) {
    class BrRecommendationTabs extends HTMLElement {
      connectedCallback() {
        setTimeout(() => {
          const buttons = Array.from(this.querySelectorAll('button[data-tab]'));
          const sectionHeader = this.closest('.section-header');
          const panelsRoot = document.getElementById(this.dataset.target);
          if (!panelsRoot || !buttons.length) return;

          const links = sectionHeader
            ? sectionHeader.querySelectorAll('.linked-to-tab')
            : [];

          buttons.forEach((button, index) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.activate(buttons, links, panelsRoot, index, button.dataset.tab);
            });
          });

          if (window.Shopify && Shopify.designMode) {
            this.addEventListener('shopify:block:select', (event) => {
              const index = buttons.findIndex(
                (button) => button === event.target || button.contains(event.target)
              );
              if (index !== -1) {
                buttons[index].dispatchEvent(new Event('click'));
              }
            });
          }

          initCarousels(panelsRoot);
        }, 10);
      }

      activate(buttons, links, panelsRoot, index, tabId) {
        buttons.forEach((button) => button.classList.remove('active'));
        buttons[index].classList.add('active');

        if (links && links.length) {
          links.forEach((link) => link.classList.remove('active'));
          const matchingLink = Array.from(links).find(
            (link) => link.getAttribute('data-tab-link') === tabId
          );
          if (matchingLink) {
            matchingLink.classList.add('active');
          } else if (links[index]) {
            links[index].classList.add('active');
          }
        }

        panelsRoot.querySelectorAll('.br-rec-tabs__panel').forEach((panel) => {
          const active = panel.getAttribute('data-tab-panel') === tabId;
          panel.classList.toggle('is-active', active);
          if (active) {
            initCarousels(panel);
            const scroller = panel.querySelector('.blm-recommendation__products');
            if (scroller) {
              scroller.scrollLeft = 0;
              scroller._brCarouselIndex = 0;
            }
            const root = panel.querySelector('.blm-recommendation-widget-content');
            if (root) updateArrows(root);
          }
        });

        window.dispatchEvent(new Event('resize'));
      }
    }

    customElements.define('br-recommendation-tabs', BrRecommendationTabs);
  }

  function getSectionsToRender() {
    return [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }
    ];
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function renderCartContents(parsedState) {
    getSectionsToRender().forEach(function (section) {
      var root = document.getElementById(section.id);
      if (!root || !parsedState.sections || !parsedState.sections[section.section]) {
        return;
      }
      var target = root.querySelector(section.selector) || root;
      target.innerHTML = getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      if (typeof drawer.removeProductEvent === 'function') {
        drawer.removeProductEvent();
      }
    }
  }

  function makeEventId(len) {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var out = '';
    try {
      var bytes = new Uint8Array(len || 10);
      crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) {
        out += chars[bytes[i] % 62];
      }
    } catch (e) {
      while (out.length < (len || 10)) {
        out += chars[Math.floor(Math.random() * 62)];
      }
    }
    return out;
  }

  function lineImageUrl(line) {
    var fi = line && line.featured_image;
    if (!fi) return line && line.image ? line.image : '';
    if (typeof fi === 'string') return fi;
    return fi.url || '';
  }

  function lineItemUrl(line) {
    if (!line || !line.url) return '';
    try {
      return new URL(line.url, window.location.origin).href;
    } catch (e) {
      return line.url;
    }
  }

  function getAtcCard(button) {
    if (!button) return null;
    return (
      button.closest('.blm-product-search__result') ||
      button.closest('.blm-recommendation__product') ||
      null
    );
  }

  function parseDollarPrice(value) {
    var n = Number(value);
    if (isNaN(n) || n <= 0) return null;
    return Math.round(n * 100);
  }

  function buildCardContextLine(button, variantId, quantity) {
    var card = getAtcCard(button);
    var vid = String(variantId);
    var mapEntry =
      window.ShopifyVariantPrices && window.ShopifyVariantPrices[vid];

    var titleEl =
      (card &&
        (card.querySelector('.blm-product-search-details-container__title') ||
          card.querySelector('.blm-product-details-container__title'))) ||
      null;

    var priceEl = card
      ? card.querySelector('.js-shopify-price[data-variant-id="' + vid + '"]') ||
        card.querySelector('.js-shopify-price')
      : null;

    var imgEl = card
      ? card.querySelector('.blm-product-search-image-container__image') ||
        card.querySelector('.blm-product-image-container__image')
      : null;

    var productId =
      button.getAttribute('data-product-id') ||
      (card && (card.getAttribute('data-product-id') || card.getAttribute('data-id')));

    var title =
      button.getAttribute('data-product-title') ||
      (titleEl ? (titleEl.textContent || '').trim() : '');

    var url =
      button.getAttribute('data-product-url') ||
      (titleEl && titleEl.href ? titleEl.href : '');

    var priceCents = null;
    if (mapEntry) {
      priceCents =
        mapEntry.logged_price != null
          ? Number(mapEntry.logged_price)
          : Number(mapEntry.price);
    }
    if ((isNaN(priceCents) || priceCents <= 0) && priceEl) {
      priceCents = parseDollarPrice(priceEl.getAttribute('data-br-price'));
    }

    var imageUrl = imgEl
      ? imgEl.getAttribute('src') || imgEl.src || ''
      : button.getAttribute('data-product-image') || '';

    return {
      variant_id: variantId,
      product_id: productId,
      quantity: quantity,
      product_title: title || null,
      title: title || null,
      price: priceCents,
      final_price: priceCents,
      sku: (mapEntry && mapEntry.item_number) || null,
      url: url,
      image: imageUrl || null,
      featured_image: imageUrl ? { url: imageUrl } : null
    };
  }

  function mergeCartLines(primary, fallback) {
    if (!fallback) return primary;
    if (!primary) return fallback;

    var merged = Object.assign({}, primary);
    var keys = [
      'variant_id',
      'product_id',
      'quantity',
      'product_title',
      'title',
      'price',
      'final_price',
      'sku',
      'url',
      'image',
      'featured_image',
      'variant_title',
      'vendor',
      'product_type',
      'currency'
    ];

    keys.forEach(function (key) {
      var value = merged[key];
      if (value == null || value === '') {
        merged[key] = fallback[key];
      }
    });

    if (merged.variant_id == null && primary.id != null && !primary.items) {
      merged.variant_id = primary.id;
    }

    return merged;
  }

  function extractAddedCartLine(response, variantId) {
    if (!response || response.status) return null;

    var vid = String(variantId);

    if (Array.isArray(response.items)) {
      for (var i = 0; i < response.items.length; i++) {
        var item = response.items[i];
        if (String(item.variant_id) === vid || String(item.id) === vid) {
          return item;
        }
      }
      return response.items[response.items.length - 1] || null;
    }

    return response;
  }

  function getAddToCartPlacement(element) {
    if (!element) return null;

    if (
      element.closest('.blm-recommendation__product') ||
      element.closest('.blm-rec-theme') ||
      element.closest('.blm-recommendations-widget')
    ) {
      return 'recommendations';
    }

    if (
      element.closest('.blm-category') ||
      element.closest('#br-product-category-container')
    ) {
      return 'product-listing-page';
    }

    if (
      element.closest('.blm-product-search') ||
      element.closest('#br-product-search-container')
    ) {
      return 'search-results';
    }

    if (
      element.closest('.thb-product-detail') ||
      element.closest('product-form') ||
      element.closest('[id^="ProductForm-"]') ||
      document.body.classList.contains('template-product')
    ) {
      return 'product-page';
    }

    return null;
  }

  function getWidgetTrackingData(button) {
    if (!button) return {};

    var contentRoot = button.closest('.blm-recommendation-widget-content');
    var hostRoot = button.closest('.blm-recommendations-widget');
    var wid = '';
    var wty = '';
    var wrid = '';

    if (contentRoot) {
      wrid = contentRoot.getAttribute('data-rid') || '';
      wid = contentRoot.getAttribute('data-id') || '';
      wty = contentRoot.getAttribute('data-type') || '';
    }

    if (hostRoot) {
      if (!wid) wid = hostRoot.getAttribute('data-id') || '';
      if (!wty) wty = hostRoot.getAttribute('data-type') || '';
    }

    return {
      wrid: wrid || null,
      wid: wid || null,
      wty: wty || null
    };
  }

  /* Mirror snippets/custom-atc-code.liquid ecommerce shape for GTM/GA4. */
  function pushRecAddToCartDataLayer(line, quantity, button) {
    if (!line) return;

    window.dataLayer = window.dataLayer || [];

    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      line.currency ||
      'USD';

    var priceCents = Number(
      line.final_price != null ? line.final_price : line.price
    );
    var price =
      !isNaN(priceCents) && priceCents > 0 ? priceCents / 100 : null;
    var qty = Number(quantity);
    if (isNaN(qty) || qty < 1) {
      qty = Number(line.quantity) || 1;
    }
    var value = price != null ? price * qty : null;

    var variantTitle =
      (line.variant_title && line.variant_title !== 'Default Title'
        ? line.variant_title
        : null) ||
      (line.sku && String(line.sku).trim()) ||
      (line.variant_id != null ? String(line.variant_id) : null);

    var variantId =
      line.variant_id != null
        ? String(line.variant_id)
        : line.id != null
          ? String(line.id)
          : null;

    var widgetTracking = getWidgetTrackingData(button);

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      event_id: makeEventId(10),
      placement: getAddToCartPlacement(button),
      wrid: widgetTracking.wrid,
      wid: widgetTracking.wid,
      wty: widgetTracking.wty,
      ecommerce: {
        currency: currency,
        value: value,
        items: [
          {
            item_id:
              (line.sku && String(line.sku).trim()) ||
              (line.product_id != null ? String(line.product_id) : null),
            item_name: line.product_title || line.title || null,
            currency: currency,
            discount: 0,
            item_category: line.product_type || null,
            index: 0,
            item_brand: line.vendor || null,
            item_variant: variantTitle,
            item_url: lineItemUrl(line),
            item_main_image: lineImageUrl(line),
            quantity: qty,
            shopify_product_id:
              line.product_id != null ? String(line.product_id) : null,
            shopify_variant_id: variantId,
            price: price
          }
        ]
      }
    });
  }

  function addRecVariantToCart(button) {
    if (!button || button.disabled || button.classList.contains('loading')) {
      return;
    }

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var quantity = Number(button.getAttribute('data-quantity') || 1);
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    var cartAddUrl =
      (window.theme && theme.routes && theme.routes.cart_add_url) ||
      '/cart/add.js';

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(quantity));
    formData.append(
      'sections',
      getSectionsToRender()
        .map(function (section) {
          return section.section;
        })
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) return;

        var contextLine = buildCardContextLine(button, variantId, quantity);
        var line = mergeCartLines(
          extractAddedCartLine(response, variantId),
          contextLine
        );

        pushRecAddToCartDataLayer(line, quantity, button);
        renderCartContents(response);
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', {
            product: line
          });
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }

  function bindAddToCart() {
    if (document.documentElement.dataset.brRecAtcBound === 'true') return;
    document.documentElement.dataset.brRecAtcBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.blm-rec-add-to-cart');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        addRecVariantToCart(button);
      },
      true
    );
  }

  var TITLE_SELECTOR = '.blm-product-search-details-container__title';
  var titleTooltipResizeTimer;
  var domWatchTimer;
  var domWatchPaused = false;
  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  function isTitleTruncated(el) {
    return el.scrollHeight > el.clientHeight + 1;
  }

  function syncTitleTooltip(el) {
    var text = (el.textContent || '').trim();
    if (!text) {
      el.removeAttribute('title');
      return;
    }

    if (isTitleTruncated(el)) {
      el.setAttribute('title', text);
    } else {
      el.removeAttribute('title');
    }
  }

  function bindTruncatedTitleTooltips(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var titles =
      root && root.matches && root.matches(TITLE_SELECTOR)
        ? [root]
        : Array.from(scope.querySelectorAll(TITLE_SELECTOR));

    titles.forEach(syncTitleTooltip);
  }

  function bindTitleTooltipResize() {
    if (document.documentElement.dataset.brTitleTooltipResize === 'true') return;
    document.documentElement.dataset.brTitleTooltipResize = 'true';

    window.addEventListener('resize', function () {
      clearTimeout(titleTooltipResizeTimer);
      titleTooltipResizeTimer = setTimeout(function () {
        runDomWatchWork();
      }, 150);
    });
  }

  function runDomWatchWork() {
    if (domWatchPaused) return;

    domWatchPaused = true;
    try {
      initCarousels(document);
      bindTruncatedTitleTooltips(document);
      if (MOBILE_MQ.matches) {
        syncMobileCollectionCardRows(document);
      }
    } finally {
      domWatchPaused = false;
    }
  }

  function scheduleDomWatchWork() {
    if (domWatchPaused || domWatchTimer) return;

    domWatchTimer = setTimeout(function () {
      domWatchTimer = null;
      runDomWatchWork();
    }, 150);
  }

  function cardHasProLoginLink(card) {
    var slot = card && card.querySelector('.blm-login-for-pro-price');
    return !!(slot && !slot.classList.contains('is-empty'));
  }

  /* On mobile 2-up rows, collapse the pro-login slot only when neither tile
     in the row needs it. Title height uses fixed CSS line-clamp instead of
     per-card DOM measurement (which was locking up the page). */
  function syncMobileCollectionCardRows(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var grids = Array.from(scope.querySelectorAll('.blm-product-search__results'));

    if (!MOBILE_MQ.matches) return;

    grids.forEach(function (grid) {
      var cards = Array.from(
        grid.querySelectorAll(':scope > .blm-product-search__result')
      );

      cards.forEach(function (card) {
        card.classList.remove('row-pair-has-pro-login', 'row-pair-no-pro-login');
      });

      for (var i = 0; i < cards.length; i += 2) {
        var cardA = cards[i];
        var cardB = cards[i + 1];

        [cardA, cardB].forEach(function (card) {
          if (!card) return;

          var partner = card === cardA ? cardB : cardA;
          var hasLogin = cardHasProLoginLink(card);
          var partnerHasLogin = cardHasProLoginLink(partner);

          if (!hasLogin && !partnerHasLogin) {
            card.classList.add('row-pair-no-pro-login');
          } else {
            card.classList.add('row-pair-has-pro-login');
          }
        });
      }
    });
  }

  function boot() {
    bindAddToCart();
    bindTitleTooltipResize();
    runDomWatchWork();

    // Widgets and collection/search grids render async after API calls.
    const mo = new MutationObserver(function () {
      scheduleDomWatchWork();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.__brInitRecCarousels = initCarousels;
})();